import React, { useCallback, useEffect, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import AcademyModuleResourceType from '@classCreation/propTypes/academyModuleResourceType';
import AcademyModuleAsyncSelect from 'components/AcademyModuleAsyncSelect';
import AcademyModuleTypeSelect from '../AcademyModuleTypeSelect';
import generateModuleTypeSelectOption from '@classCreation/utils/generateModuleTypeSelectOption';
import styles from './AcademyModuleInput.module.scss';

const parseAcademyModule = (academyModule) =>
  academyModule
    ? {
        label: academyModule?.name,
        value: academyModule?.id,
      }
    : null;

export default function AcademyModuleInput({
  value,
  onChange,
  disabled = false,
}) {
  const [moduleType, setModuleType] = useState(
    value ? generateModuleTypeSelectOption(value.category) : null
  );
  const [academyModule, setAcademyModule] = useState(parseAcademyModule(value));

  useEffect(() => {
    if (value) {
      setModuleType(generateModuleTypeSelectOption(value.category));
      setAcademyModule(parseAcademyModule(value));
    } else {
      setAcademyModule(null);
    }
  }, [value]);

  const handleModuleTypeChange = useCallback(
    (option) => {
      setModuleType(option);
      setAcademyModule(null);
      onChange(null);
    },
    [onChange]
  );

  const handleAcademyModuleChange = useCallback(
    (option) => {
      setAcademyModule(option);
      onChange({
        ...value,
        category: option.category,
        name: option?.label,
        id: option?.value,
      });
    },
    [onChange, value]
  );

  return (
    <div className="row">
      <AcademyModuleTypeSelect
        value={moduleType}
        isDisabled={disabled}
        onChange={handleModuleTypeChange}
        className={classNames(styles.input, 'm-r-xs')}
      />
      {moduleType && (
        <AcademyModuleAsyncSelect
          category={moduleType?.value}
          value={academyModule}
          onChange={handleAcademyModuleChange}
          className={styles.input}
          isDisabled={disabled}
        />
      )}
    </div>
  );
}

AcademyModuleInput.propTypes = {
  value: AcademyModuleResourceType,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};
